import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function FeaturedArticles() {
  const featured = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100" id="articles-section">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12">
          <div>
            <p className="text-xs text-foreground-500 tracking-widest uppercase mb-2">春季攻略</p>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
              精选春日文章
            </h2>
            <p className="mt-2 text-foreground-600 text-sm">
              由旅行达人亲身体验后撰写的深度攻略
            </p>
          </div>
          <Link
            to="/category/east-asia"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}